import { Flex, Form as AForm, Modal, Select } from 'antd';
import { Button } from 'shared/ui/Button/Button';
import React, { useState } from 'react';
import { TextInput } from 'shared/ui/form/Input';

export const AddFilterModal: React.FC<{
  show: boolean;
  queryOptions: {
    fromCreatedAtDate?: string;
    toCreatedAtDate?: string;
    paymentStatus?: string;
  };
  onClose: () => void;
  onSearchChange: (p: {
    fromCreatedAtDate?: string;
    toCreatedAtDate?: string;
    paymentStatus?: string;
  }) => void;
}> = ({ show, queryOptions, onClose, onSearchChange }) => {
  const [fromCreatedAtDate, setFromCreatedAtDate] = useState(
    queryOptions.fromCreatedAtDate || ''
  );
  const [toCreatedAtDate, setToCreatedAtDate] = useState(
    queryOptions.toCreatedAtDate || ''
  );
  const [paymentStatus, setPaymentStatus] = useState(
    queryOptions.paymentStatus || undefined
  );

  const handleApplyFilter = () => {
    if (
      fromCreatedAtDate !== queryOptions.fromCreatedAtDate ||
      toCreatedAtDate !== queryOptions.toCreatedAtDate ||
      paymentStatus !== queryOptions.paymentStatus
    ) {
      onSearchChange({ fromCreatedAtDate, toCreatedAtDate, paymentStatus });
      onClose();
    }
  };

  const handleResetFilter = () => {
    setFromCreatedAtDate('');
    setToCreatedAtDate('');
    setPaymentStatus('');
  };

  const _handleChangeFromDate = (evt: React.ChangeEvent<HTMLInputElement>) => {
    setFromCreatedAtDate(evt.target.value);
  };

  const _handleChangeToDate = (evt: React.ChangeEvent<HTMLInputElement>) => {
    setToCreatedAtDate(evt.target.value);
  };

  const _handlePaymentStatus = (val: string) => {
    setPaymentStatus(val);
  };

  return (
    <Modal
      title="Filter Invoices"
      open={show}
      footer={null}
      centered
      destroyOnClose
      onCancel={onClose}>
      <Flex className={'mt-4'} gap={'middle'}>
        <AForm.Item className={'flex-1'} layout="vertical" label="From Date">
          <TextInput
            id="fromCreatedAtDate"
            type="date"
            color={'darkSlate'}
            value={fromCreatedAtDate}
            onChange={_handleChangeFromDate}
          />
        </AForm.Item>

        <AForm.Item className={'flex-1'} layout="vertical" label="To Date">
          <TextInput
            id="toCreatedAtDate"
            type="date"
            color={'darkSlate'}
            value={toCreatedAtDate}
            onChange={_handleChangeToDate}
          />
        </AForm.Item>
      </Flex>

      <AForm.Item layout="vertical" label="Payment Status">
        <Select
          size={'large'}
          value={paymentStatus}
          onChange={_handlePaymentStatus}
          placeholder={'Select invoice payment status'}
          options={[
            {
              value: 'paid',
              label: 'Paid',
            },
            {
              value: 'unpaid',
              label: 'Unpaid',
            },
          ]}
        />
      </AForm.Item>

      <Flex justify={'flex-end'} className={'pt-4'} gap={'middle'}>
        <Button color="slate" onClick={handleResetFilter}>
          Reset
        </Button>
        <Button color="indigo" onClick={handleApplyFilter}>
          Apply
        </Button>
      </Flex>
    </Modal>
  );
};
